import { z } from "zod";

import {
  THEME_ROUNDNESS,
  THEME_ROUNDNESS_NAMES,
  type ThemeRoundness,
} from "../canvas/radiusScale.ts";
import { ColorTokens } from "../canvas/theme.ts";

import {
  DEFAULT_FONT_FAMILIES,
  DEFAULT_SPACING,
} from "./builtin/defineBuiltinTheme.ts";
import type { StoredThemeTokens } from "./storedTheme.ts";

export const GeneratedTheme = z.object({
  name: z.string().min(1).max(60),
  roundness: z.enum(
    THEME_ROUNDNESS_NAMES as [ThemeRoundness, ...ThemeRoundness[]],
  ),
  color: z.object({ light: ColorTokens, dark: ColorTokens }),
});
export type GeneratedTheme = z.infer<typeof GeneratedTheme>;

export const assembleGeneratedTheme = (
  generated: GeneratedTheme,
): StoredThemeTokens => ({
  color: generated.color,
  radius: { base: THEME_ROUNDNESS[generated.roundness] },
  spacing: DEFAULT_SPACING,
  typography: { families: DEFAULT_FONT_FAMILIES },
});
